import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
	TVatReimbursementsRequest,
	TReceiveVatReimbursementRequest,
	TUpdateCommentRequest,
} from 'redux/reducers/vatReimbursement/types';
import { TVatReimbursementApi } from './types';

export const vatReimbursement: TVatReimbursementApi = {
	getVatReimbursements: (payload: TVatReimbursementsRequest) => {
		return http
			.post(endpoint.vatReimbursement.VAT_REIMBURSEMENTS, payload)
			.then(response => response.data);
	},
	receiveVatReimbursement: (payload: TReceiveVatReimbursementRequest) => {
		return http
			.put(endpoint.vatReimbursement.RECEIVE_VAT_REIMBURSEMENT(payload.id), payload.body)
			.then(response => response.data);
	},
	updateComment: (payload: TUpdateCommentRequest) => {
		return http
			.put(endpoint.vatReimbursement.UPDATE_COMMENT(payload.id), payload.body)
			.then(response => response.data);
	},
};
